module.exports = __webpack_public_path__ + "static/media/TakePicture.5ff3bbce.svg";